import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';

const get = ({ page, _id, name, enabled, type, campaignType, },) => {
  const size = 15;
  const from = ((page || 1) - 1) * size;

  if (_id) {return BaseHttp.
    get(`/campaign/${_id}`,);}


  const queryObj = {
    name: name || undefined,
    enabled,
    type,
    size,
    from: from || undefined,
  };

  if (campaignType && campaignType !== 'ALL') {
    queryObj.campaign_type = campaignType;
  }

  const query = `/campaign${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(query,);
};

const getBonds = (_id, page,) => {
  const size = 15;
  const from = ((page || 1) - 1) * size;

  const queryObj = {
    campaign_id: _id,
    size,
    from: from,
  };

  const query = `/company/campaign${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(query,);
};

const put = (campaign,) => {
  return BaseHttp.put('/campaign', campaign,);
};

const patch = ({ campaignId, input, },) => {
  return BaseHttp.patch(`/campaign/${campaignId}`, input,);
};

const post = (campaign,) => {
  return BaseHttp.post('/campaign', campaign,);
};

const removeCampaign = (_id,) => {
  return BaseHttp.delete(`/campaign/${_id}`,);
};

const enable = (_id,) => {
  return BaseHttp.post(`/campaign/enable/${_id}`,);
};

const disable = (_id,) => {
  return BaseHttp.post(`/campaign/disable/${_id}`,);
};

const campaignInfo = (_id,) => {
  return BaseHttp.get(`/campaign/${_id}/info`,);
};

const deleteImage = (image,) => {
  return BaseHttp.delete(`/public/s3/file/?file_url=${image}`,);
};

const getProductCategories = () => {
  return BaseHttp.get('product-campaign-categories',);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  get,
  put,
  patch,
  post,
  removeCampaign,
  getBonds,
  enable,
  disable,
  campaignInfo,
  deleteImage,
  getProductCategories,
  handleError,
};
